module.exports = __webpack_public_path__ + "img/prostate-cancer-leaflet.b479f96d.jpg";